'use client'
 
import { useEffect } from 'react'
import Image from "next/image"
import Logo from "@/assets/logo-v2.svg"
import { Button } from '@/components/elements/Button'
import { RotateCcw } from 'lucide-react'
 
export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className='h-screen flex flex-col items-center justify-center gap-4'>
      <Image src={Logo} alt='logo' width={150} height={80} />
      <h1 className='font-gilroy text-xl font-semibold'>Ямар нэгэн алдаа гарлаа!</h1>
      <code className='bg-muted px-4 py-2 rounded-lg text-sm font-medium'>{error.message}</code>
      <Button icon={RotateCcw} onClick={() => reset()} >
        Дахин оролдох
      </Button>
    </div>
  )
}